import { render, staticRenderFns } from "./BusinessPrescriptionsReport.vue?vue&type=template&id=638b4c3c&scoped=true"
import script from "./BusinessPrescriptionsReport.vue?vue&type=script&lang=js"
export * from "./BusinessPrescriptionsReport.vue?vue&type=script&lang=js"
import style0 from "./BusinessPrescriptionsReport.vue?vue&type=style&index=0&id=638b4c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b4c3c",
  null
  
)

export default component.exports